"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsSelectedControl = void 0;
var lodash_1 = require("lodash");
var useControlGroup_1 = require("./useControlGroup");
var useIsSelectedControl = function (value) {
    var selected = (0, useControlGroup_1.useControlGroup)().selected;
    return Array.isArray(selected)
        ? selected === null || selected === void 0 ? void 0 : selected.includes(value)
        : (0, lodash_1.isEqual)(value, selected);
};
exports.useIsSelectedControl = useIsSelectedControl;
